import { FC } from 'react';

import { ImageData } from '../VariationOne';
import {
  SettingsModal as SharedSettingsModal,
  WATERMARK_SECTIONS,
  withWatermarkDefaults,
} from '../shared';

interface Props {
  image: ImageData;
  imageIndex: number;
  onClose: () => void;
  setImages: React.Dispatch<React.SetStateAction<ImageData[]>>;
}

/** Watermark settings for the main cover image (the circular image has its own modal) */
const WatermarkSettingsModal: FC<Props> = ({ image, ...props }) => (
  <SharedSettingsModal
    {...props}
    image={withWatermarkDefaults(image)}
    title="Image Parameters"
    sections={WATERMARK_SECTIONS}
  />
);

export default WatermarkSettingsModal;
